module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/industry-03-0733596e343b3e2e91f9a49a2a8ee73a.png";